import { Close as CloseIcon } from '@mui/icons-material'
import { IconButton, useTheme } from '@mui/material'
import { useSnackbar } from 'notistack'

interface Props {
  key?: string
}

const CloseButton = ({ key }: Props) => {
  const { closeSnackbar } = useSnackbar()
  const theme = useTheme()

  const onClick = () => closeSnackbar(key)

  return (
    <IconButton onClick={onClick} size="small">
      <CloseIcon sx={{ fill: theme.palette.common.white }} />
    </IconButton>
  )
}

export { CloseButton }
